import React, { Fragment } from 'react';
import Container from '../../../../constants/Container';
import { formatMoney_2 } from '../../../../helpers/DateFormat';

interface TransRptProps {
    onTransReport: any
}
const TranRptListView: React.FC<TransRptProps> = ({ onTransReport }) => {
    return (
        <Fragment>
            <Container padding>
                <div className="relative overflow-x-auto">
                    <table className="text-sm text-left rtl:text-right text-sky-900 whitespace-nowrap scroll-x-auto dark:text-slate-400 rounded w-full">
                        <thead className="text-[12px] text-gray700 bg-slate-100 dark:bg-sky-950 capitalize border-b dark:bg-slate900 dark:text-slate-400 font-public-sans">
                            <tr>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-10">
                                    S.N.
                                </th>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-10">
                                    GLID
                                </th>
                                <th scope="col" rowSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800">
                                    Particulars
                                </th>
                                <th scope="col" colSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Debit Amount
                                </th>

                                <th scope="col" colSpan={2} align='center' className="px-2 border border-slate-300 dark:border-sky-800 w-[25%]">
                                    Credit Amount
                                </th>

                            </tr>
                            <tr>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Amount
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Total Amount
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Amount
                                </th>
                                <th scope="col" align='center' className="px-2 border border-gray-300 dark:border-sky-800">
                                    Total Amount
                                </th>
                            </tr>
                        </thead>
                        <tbody className='text-slate-800'>
                            {Array.isArray(onTransReport?.results) &&
                                onTransReport?.results?.map((ledger: any, index: number) =>
                                (
                                    <tr key={index} className="odd:bg-white hover:bg-slate-100 text-[12px] text-gray-800 dark:text-gray-400 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-gray-700">
                                        <td align='center' className="px-2 border border-gray-300 font-medium dark:border-sky-800 capitalize">
                                            {index + 1}.
                                        </td>
                                        <td align='center' className="px-2 border border-gray-300 font-medium dark:border-sky-800 capitalize">
                                            {`${ledger?.sub_ledg_id === 0 ? ledger?.glid : ledger?.glid + "." + ledger?.sub_ledg_id}`}
                                        </td>
                                        <td align='left' className="px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px]">
                                            <span className='font-semibold underline'>{ledger?.sub_ledg_id === 0 ? ledger?.gl_name : ""} </span> <span className='pl-14 font-normal'>{ledger?.sub_ledg_id !== 0 ? ledger?.sub_ledg_name : ""}</span>
                                        </td>
                                        <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                            {ledger?.subdr ? formatMoney_2(ledger?.subdr) : formatMoney_2(0)}
                                        </td>
                                        <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                            {ledger?.totdr ? formatMoney_2(ledger?.totdr) : formatMoney_2(0)}
                                        </td>
                                        <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                            {ledger?.subcr ? formatMoney_2(ledger?.subcr) : formatMoney_2(0)}
                                        </td>
                                        <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                            {ledger?.totcr ? formatMoney_2(ledger?.totcr) : formatMoney_2(0)}
                                        </td>

                                    </tr>
                                )
                                )
                            }
                            {/* <tr className='font-public-sans text-black bg-gray100'>
                                <td align='right' colSpan={3} className="px-2 font-medium border border-gray-300 dark:border-sky-800 uppercase text-[12px]">
                                    Total
                                </td>
                                <td align='right' colSpan={2} className="px-2 font-medium border border-gray-300 dark:border-sky-800 capitalize text-[12px]">
                                    {totalAmt?.totalDRAmt ? MoneyFormat(totalAmt?.totalDRAmt) : MoneyFormat(0)}
                                </td>
                                <td align='right' colSpan={2} className="px-2 font-medium border border-gray-300 dark:border-sky-800 capitalize text-[12px]">
                                    {totalAmt?.totalCRYear ? MoneyFormat(totalAmt?.totalCRYear) : MoneyFormat(0)}
                                </td>
                                <td align='right' className="px-2 font-medium border border-gray-300 dark:border-sky-800 capitalize text-[12px]">

                                </td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            </Container>
        </Fragment>
    )
}

export default TranRptListView